<script setup lang="ts">
  import Popup from '@/components/Popup.vue'
  import { ChevronDown, UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    label: string
    clearable?: boolean
  }>()

  const emit = defineEmits<{
    clear: []
  }>()

  defineSlots<{
    default: () => unknown
  }>()

  function clear(close: () => void) {
    emit('clear')
    close()
  }
</script>

<template>
  <Popup>
    <template #trigger="{ open, toggle }">
      <button type="button" class="trigger" :aria-expanded="open" @click="toggle">
        {{ label }}
        <ChevronDown class="chevron" :class="{ 'is-open': open }" />
      </button>
    </template>

    <template #default="{ close }">
      <slot />

      <div v-if="clearable" class="popup-footer">
        <UiButton variant="link" label="Wissen" @click="clear(close)" />
      </div>
    </template>
  </Popup>
</template>

<style scoped>
  .trigger {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: 0;
    border: none;
    background: none;
    color: var(--colours-brand-colour-1);
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
  }

  .chevron {
    width: 1rem;
    height: 1rem;
    transition: transform 150ms ease-in-out;
  }

  .chevron.is-open {
    transform: rotate(180deg);
  }

  .popup-footer {
    display: flex;
    justify-content: end;
    margin-top: var(--spacing-s);
  }

  @media (prefers-reduced-motion: reduce) {
    .chevron {
      transition: none;
    }
  }
</style>
